<template>
    <AppModal ref="modal" :title="$t('labels.edit_filters')" size="lg" @on-hide="hide">
        <div class="modal-body">
            <div class="table-responsive" v-if="!task.state.isRunning && loadingBadHttpHistory.length === 0">
                <table class="table table-bordered table-fixed">
                    <thead>
                        <tr>
                            <th width="50%">{{ $t('labels.field') }}</th>
                            <th width="50%">{{ $t('labels.action') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(field, index) in fields" :key="field.name">
                            <tr>
                                <td>{{ field.label }}</td>
                                <td>
                                    <AppSelect
                                        option-key="key"
                                        option-value="value"
                                        :model-value="field.selectedAction?.key"
                                        :selected-value="field.selectedAction?.value"
                                        :options="getFieldActions()"
                                        @update:model-value="selectAction($event, index)"
                                        can-be-empty
                                    />
                                </td>
                            </tr>
                            <FieldActionEditor
                                :action="field.selectedAction"
                                :type="field.type"
                                :add-select-options="[]"
                                :replace-select-options="[]"
                                v-model="field.dataForProcessing"
                            />
                        </template>
                    </tbody>
                </table>
            </div>
            <TaskProgressBar v-else-if="task.state.isRunning" :done="task.state.done" :total="task.state.total"/>
            <slot v-else-if="!task.state.isRunning && loadingBadHttpHistory.length > 0">
                <div class="alert alert-warning border-0 alert-dismissible mt-3">
                    <button type="button" class="close" data-dismiss="alert"><span>×</span></button>
                    <div v-html="$t('alerts.bad_response')"></div>
                </div>
                <div class="table-responsive table-scrollable">
                    <table class="table table-bordered table-fixed">
                        <thead>
                            <tr>
                                <th>{{ $t('labels.request') }}</th>
                                <th>{{ $t('labels.response') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(badHttpHistoryItem, i) in loadingBadHttpHistory" :key="i">
                                <td><span class="text-nowrap">{{ badHttpHistoryItem.request.body }}</span></td>
                                <td><span class="text-nowrap">{{ badHttpHistoryItem.response.body }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </slot>
        </div>
        <div class="modal-footer" v-if="!task.state.isRunning && loadingBadHttpHistory.length === 0">
            <AppButton @click="updateFilters" size="sm" color="indigo">
                {{ $t('buttons.edit') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import AppSelect from '../../../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../../../components/new/button/AppButton.vue';
import FieldActionEditor from '../../../modals/components/FieldActionEditor.vue';
import TaskProgressBar from '../../../../../../components/new/progress/TaskProgressBar.vue';
import HttpRequest from '../../../../../../services/Http/HttpRequest';
import HttpSender from '../../../../../../services/Http/HttpSender';
import { createProgressTask } from '../../../../../../services/Progress/ProgressTask';

export default {
    name: "EditFilterModal",
    components: {
        AppModal, AppSelect, AppButton, FieldActionEditor, TaskProgressBar
    },
    data() {
        return {
            task: createProgressTask(),
            fields: [],
            selectedFilterUuids: [],
            loadingBadHttpHistory: [],
            httpSender: new HttpSender(),
        };
    },
    emits: ['filters:edited'],
    methods: {
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.selectedFilterUuids = [];
            this.loadingBadHttpHistory = [];
            this.fields = [];
        },
        initializeFields() {
            this.fields = [
                {
                    name: 'ai_use_in_product_description',
                    label: this.$t('table.titles.ai_use_in_product_description'),
                    selectedAction: null,
                    dataForProcessing: null,
                    type: 'checkbox'
                },
            ];
        },
        getFieldActions() {
            return [
                { key: 'change', value: this.$t('batchUpdateProductModal.actions.change') }
            ];
        },
        selectAction(action, index) {
            this.fields[index].selectedAction = action;
            this.fields[index].dataForProcessing = action ? { value: null } : null;
        },
        show(filterUuids) {
            if (!filterUuids.length) {
                return;
            }
            this.selectedFilterUuids = filterUuids;
            this.initializeFields();
            this.$refs.modal.show();
        },
        buildUpdateRequest() {
            const updateRequest = {};
            this.fields
                .filter(field => field.selectedAction)
                .forEach(field => {
                    if (field.selectedAction.key === 'change') {
                        updateRequest[field.name] = field.dataForProcessing.value ? 1 : 0;
                    }
                });
            return updateRequest;
        },
        async updateFilters() {
            const updateRequest = this.buildUpdateRequest();
            const allUpdateRequests = this.selectedFilterUuids.map(uuid =>
                new HttpRequest('PATCH', `/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters/${uuid}`, updateRequest)
            );

            const completed = await this.task.run(async ({setTotal, tick}) => {
                setTotal(allUpdateRequests.length);

                await this.httpSender.sendRequestsInBatches(allUpdateRequests, () => tick());
            });

            if (!completed) {
                return;
            }

            this.loadingBadHttpHistory = this.httpSender.getHistory().filter(historyItem => {
                return historyItem.response.status !== 201 && historyItem.response.status !== 200;
            });

            this.$emit('filters:edited');

            if (this.loadingBadHttpHistory.length === 0) {
                this.hide();
            }
        },
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>
